<div [class.mb-12]="hideDivider">
    <mat-radio-group class="radio-group-inline" [formControl]="typeControl">
        <mat-radio-button [value]="'all'">{{ 'workflows.formWidgets.boat.allBoats' | translate }}</mat-radio-button>
        <mat-radio-button [value]="'person'">{{ 'workflows.formWidgets.boat.boatsFromPerson' | translate }}</mat-radio-button>
        <mat-radio-button [value]="'organisation'">{{ 'workflows.formWidgets.boat.boatsFromCompany' | translate }}</mat-radio-button>
    </mat-radio-group>
</div>

<ng-container *ngIf="typeControl.value === 'person'">
    <ng-container *ngIf="!hideDivider">
        <mat-divider class="special-divider"></mat-divider>
    </ng-container>
    <form-widget-person [canCreate]="false" [appearance]="appearance"
                        [optionalFields]="false" [slimmedView]="true"></form-widget-person>
</ng-container>

<ng-container *ngIf="typeControl.value === 'organisation'">
    <ng-container *ngIf="!hideDivider">
        <mat-divider class="special-divider"></mat-divider>
    </ng-container>
    <form-widget-company [canCreate]="false" [appearance]="appearance"
                         [optionalFields]="false" [slimmedView]="true"></form-widget-company>
</ng-container>

<ng-container *ngIf="!hideDivider">
    <mat-divider class="special-divider"></mat-divider>
</ng-container>

<form-widget-boat [canCreate]="false" [appearance]="appearance" [selectBoat]="boat"
                  [boatOwnerName]="boatOwnerName" [person$]="person$" [company$]="company$"
                  [slimmedView]="true"></form-widget-boat>
